var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "circular-wrapper"
  }, [_c("img", {
    staticClass: "drawImg",
    attrs: {
      src: require("../../../../assets/lottery/draw.png"),
      alt: ""
    },
    on: {
      click: _vm.rotateCirculat
    }
  }), _c("div", {
    staticClass: "baseBg",
    style: {
      transform: "rotate(" + _vm.rotate + "deg)",
      transition: _vm.rotateStatus ? "all " + _vm.duringTime + "s ease-in-out" : ""
    }
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };